import {Component, OnDestroy, OnInit} from '@angular/core';
import {FesBaseComponent} from "../../shared/components/fes-base.component";
import {AppState} from "../../core";
import {FormBuilder, Validators} from "@angular/forms";
import {BsModalRef} from "ngx-bootstrap/modal";
import {Market} from "../../core/models/market";
import {MarketService} from "../../core/services/market.service";

@Component({
    selector: 'app-market-edit',
    templateUrl: './market-edit.component.html',
    styleUrls: ['./market-edit.component.scss']
})
export class MarketEditComponent extends FesBaseComponent implements OnInit {
    marketForm: any;
    edit: boolean = false;
    private market: Market;
    timezones: any

    constructor(
        appState: AppState,
        private formBuilder: FormBuilder,
        protected editModal: BsModalRef,
        private marketService: MarketService
    ) {
        super(appState)
    }

    onSaveMarket = () => {
    }
    bProcessing: boolean = false;

    async ngOnInit() {
        this.getTimeZones()
        this.createForm()
        if (this.market) {
            this.marketForm.patchValue(this.market)
            this.edit = true;
        }
    }

    private createForm() {
        this.marketForm = this.formBuilder.group({
            name: ['', Validators.required],
            timezone: ['', Validators.required]
        })
    }

    submitMarket() {
        if (this.marketForm.invalid) {
            Object.keys(this.marketForm.controls).map((single_control)=>{
                if (this.marketForm.controls[single_control].invalid){
                   this.marketForm.controls[single_control].markAsDirty()
                }
            })
            this.appState.notifyError("Please fill required fields", AppState, 1000);
            return;
        }

        this.marketService.createUpdateMarket(this.marketForm.value, this.market?.name, this.edit).subscribe((data: any) => {
            this.onSaveMarket()
            this.editModal.hide()
            this.appState.notifySuccess(`Market has been ${this.edit ? 'updated' : 'created'} successfully`, AppState, 1000);
        }, (error) => {
            this.appState.notifyError(error.error.msg, AppState, 1000);
        })
    }

    onCancel() {
        this.editModal.hide()
    }

    public setMarket(market: Market = null) {
        if (market != null) {
            this.market = market;
        }
    }

    private getTimeZones() {
        this.timezones = this.marketService.getTimeZones();
    }

}
